import { formatChatFileSize, MAIL_ATTACHMENT_LIMITS, mailAttachmentLimitsSentence } from '@zerohuman/shared'
import type { MailAttachmentUpload } from '@/api'

/** Why these files cannot go on one mail, or null when they can: the shared limits, judged before anything is read. */
export function attachmentsRefusal(files: readonly File[]): string | null {
    const total = files.reduce((sum, file) => sum + file.size, 0)
    if (files.length > MAIL_ATTACHMENT_LIMITS.maxFiles || total > MAIL_ATTACHMENT_LIMITS.maxTotalBytes) {
        return `These files are ${formatChatFileSize(total)}; a mail carries ${mailAttachmentLimitsSentence()}.`
    }
    return null
}

/** A file's bytes as base64, a chunk at a time so a large file never builds one enormous argument list. */
function base64Of(bytes: Uint8Array): string {
    let binary = ''
    const chunk = 0x8000
    for (let offset = 0; offset < bytes.length; offset += chunk) {
        binary += String.fromCharCode(...bytes.subarray(offset, offset + chunk))
    }
    return btoa(binary)
}

/** The files as the API takes them on a sent mail. */
export async function uploadsOf(files: readonly File[]): Promise<MailAttachmentUpload[]> {
    return Promise.all(
        files.map(async file => ({
            filename: file.name,
            contentType: file.type || 'application/octet-stream',
            base64: base64Of(new Uint8Array(await file.arrayBuffer())),
        })),
    )
}
